module.exports = __webpack_public_path__ + "media/images/triangle-623069074fc2050078b4338dd6858d43.png";